import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import {
  GetTutorialStateRequest,
  GetTutorialStateResponse,
  PostTutorialStateRequest,
  PostTutorialStateResponse,
  TutorialFeatureMap,
  TutorialProgressStateMap,
  TutorialState,
} from "../proto/api_pb";
import { RpcError } from "grpc-web";

export const getTutorialState = async (
  accessToken: string,
  userId: string,
  tutorialFeature :TutorialFeatureMap[keyof TutorialFeatureMap]
): Promise<GetTutorialStateResponse | RpcError | undefined> => {

  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTutorialStateRequest();
    request.setUserId(userId);
    request.setTutorialFeature(tutorialFeature);
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<GetTutorialStateResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTutorialState(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    if (e instanceof RpcError) {
      return e;
    }
  }
};

export const updateTutorialState = async (
  accessToken: string,
  userId: string,
  tutorialProgressState: TutorialProgressStateMap[keyof TutorialProgressStateMap],
  tutorialFeature: TutorialFeatureMap[keyof TutorialFeatureMap]
): Promise<RpcError | PostTutorialStateResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostTutorialStateRequest();
    const requestBody = new TutorialState();
    requestBody.setUserId(userId);
    requestBody.setTutorialFeature(tutorialFeature);
    requestBody.setTutorialProgressState(tutorialProgressState);
    request.setTutorialState(requestBody);

    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<PostTutorialStateResponse | RpcError>((resolve, reject) => {
          ommuseClient.postTutorialState(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
